// extracted by mini-css-extract-plugin
export default {"signin_form":"_1mp8IG0-PRyLa7Tzwvdve4"};